import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsPersonCircle } from 'react-icons/bs';
import { MdAddAPhoto } from 'react-icons/md';
import CountryCodes from 'assets/json/countries.json';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import TextInput from 'components/TextInput';
import { auth, signOut } from 'config/firebase';
import axios from 'config/axios';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { signIn } from 'store/user';
import { setError, setAlert } from 'store/error';
import './index.css';

function PersonalInfo() {
    const { user } = useAppSelector(state => state.user);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    
    const [profilePhoto, setProfilePhoto] = useState(user.profilePhoto);
    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [email, setEmail] = useState(user.email);
    const [country, setCountry] = useState(user.countryCode
        ?   <div className='personalInfo__country' id={CountryCodes.find(country => country.isoCode === user.countryCode).isoCode}>
                <img src={CountryCodes.find(country => country.isoCode === user.countryCode).flag} />
                &nbsp;&nbsp;
                <p>{CountryCodes.find(country => country.isoCode === user.countryCode).dialCode}</p>
                {/* &nbsp;&nbsp;
                <p>{CountryCodes.find(country => country.dialCode === user.countryCode).name}</p> */}
            </div>
        :   <div className='personalInfo__country'></div>
    );
    const [countryCode, setCountryCode] = useState(user.countryCode);
    const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber);
    const [birthDate, setBirthDate] = useState(user.birthDate ? user.birthDate.toString() : null);
    const [gender, setGender] = useState(user.gender);
    const [highSchool, setHighSchool] = useState(user.highSchool);
    const [classOf, setClassOf] = useState(user.classOf);
    const [postalCode, setPostalCode] = useState(user.postalCode);

    const updateProfile = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        axios.post('students/update/', {
                firstName: firstName,
                lastName: lastName,
                countryCode: countryCode,
                phoneNumber: phoneNumber,
                gender: gender,
                birthDate: birthDate,
                highSchool: highSchool,
                classOf: classOf,
                postalCode: postalCode
            })
            .then(res => {
                // console.log(res.data);
                dispatch(signIn(res.data?.user));
            })
            .catch(error => {
                // console.log(error);
                dispatch(setAlert(error));
            });
    }

    const updateProfilePhoto = (event: React.ChangeEvent<HTMLInputElement>) => {
        let formData = new FormData();
        formData.append('profilePhoto', Array.from(event.target.files)[0]);
        
        axios.post('students/profilePhoto/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                // console.log(res.data);
                setProfilePhoto(res.data.profilePhoto);
            })
            .catch(error => {
                // console.log(error);
                dispatch(setAlert(error));
            });
    }

    const handleSignOut = () => {
        signOut(auth)
            .then(() => {
                // console.log('Signed out!');
                navigate('/');
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }

    return (
        <div className='personalInfo'>
            <div className='personalInfo__column'>
                <form className='personalInfo__form' onSubmit={updateProfile}>
                    <label className='personalInfo__photo' htmlFor='profilePhoto'>
                        <input
                            id='profilePhoto'
                            accept='image/*'
                            type='file'
                            onChange={updateProfilePhoto}
                        />
                        {profilePhoto
                            ? <img className='personalInfo__photoImage' src={profilePhoto} />
                            : <BsPersonCircle className='personalInfo__photoImage' />
                        }
                        <p className='personalInfo__photoAdd'>
                            <MdAddAPhoto />
                            {profilePhoto
                                ? 'UPDATE PHOTO'
                                : 'ADD PHOTO'
                            }
                        </p>
                    </label>
                    <TextInput
                        name='email'
                        label='Email'
                        onChange={(event) => setEmail(event.target.value)}
                        type='text'
                        required
                        value={email}
                        disabled
                    />
                    <div className='personalInfo__formGrid'>
                        <TextInput
                            className='personalInfo__formGridItem'
                            name='firstName'
                            label='First name'
                            onChange={(event) => setFirstName(event.target.value)}
                            type='text'
                            required
                            value={firstName}
                        />
                        <TextInput
                            className='personalInfo__formGridItem'
                            name='lastName'
                            label='Last name'
                            onChange={(event) => setLastName(event.target.value)}
                            type='text'
                            required
                            value={lastName}
                        />
                    </div>
                    <div className='personalInfo__formGrid'>
                        <Dropdown
                            className='personalInfo__formGridItem'
                            data={CountryCodes.map(country => (
                                <div className='personalInfo__country' id={country.isoCode}>
                                    <img src={country.flag} />
                                    &nbsp;&nbsp;
                                    <p>{country.dialCode}</p>
                                    {/* &nbsp;&nbsp;
                                    <p>{country.name}</p> */}
                                </div>
                            ))}
                            onSelect={(value) => {
                                setCountryCode(value.props.id);
                                setCountry(value);
                            }}
                            label='Country Code'
                            value={country}
                        />
                        <TextInput
                            className='personalInfo__formGridItem'
                            name='phoneNumber'
                            label='Phone number'
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '');
                                if (value.length <= 15) setPhoneNumber(value);
                            }}
                            type='text'
                            value={phoneNumber}
                        />
                    </div>
                    <div className='personalInfo__formGrid'>
                        <TextInput
                            className='personalInfo__formGridItem'
                            name='dateOfBirth'
                            label='Date of birth'
                            onChange={(event) => setBirthDate(event.target.value)}
                            type='date'
                            value={birthDate}
                        />
                        <Dropdown
                            className='personalInfo__formGridItem'
                            data={['Male', 'Female', 'Prefer not to say']}
                            onSelect={(value) => setGender(value)}
                            label='Gender'
                            value={gender}
                        />
                    </div>
                    <TextInput
                        name='highSchool'
                        label='High school'
                        onChange={(event) => setHighSchool(event.target.value)}
                        type='text'
                        value={highSchool}
                    />
                    <div className='personalInfo__formGrid'>
                        <Dropdown
                            className='personalInfo__formGridItem'
                            data={[...Array(50)].map((_, i) => new Date().getFullYear() + 5 - i)}
                            onSelect={(value) => setClassOf(value)}
                            label='Class of'
                            value={classOf}
                        />
                        <TextInput
                            className='personalInfo__formGridItem'
                            name='postalCode'
                            label='Zip code'
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '');
                                if (value.length <= 12) setPostalCode(value);
                            }}
                            type='text'
                            value={postalCode}
                        />
                    </div>
                    <Button
                        className='personalInfo__submit'
                        secondary={
                            email === user.email &&
                            countryCode === user.countryCode &&
                            phoneNumber === user.phoneNumber &&
                            firstName === user.firstName &&
                            lastName === user.lastName &&
                            (user.birthDate ? birthDate === user.birthDate.toString() : !birthDate) &&
                            gender === user.gender &&
                            highSchool === user.highSchool &&
                            classOf === user.classOf &&
                            postalCode === user.postalCode
                        }
                        type='submit'
                    >
                        UPDATE PROFILE
                    </Button>
                </form>
                <Button
                    className='personalInfo__signOut'
                    secondary
                    onClick={handleSignOut}
                >
                    SIGN OUT
                </Button>
            </div>
        </div>

    );
}

export default PersonalInfo;